import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import { SUPPORTED_LANGUAGES } from '../i18n'

export function LanguageSwitcher({ dark }: { dark?: boolean } = {}) {
  const { i18n, t } = useTranslation()
  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="sr-only">{t('nav.language')}</span>
      <select
        aria-label={t('nav.language')}
        value={i18n.language}
        onChange={(e) => void i18n.changeLanguage(e.target.value)}
        className={clsx('input !w-auto cursor-pointer', dark && 'border-white/20 bg-white/5 text-white')}
      >
        {SUPPORTED_LANGUAGES.map(({ code, label }) => (
          <option key={code} value={code}>
            {label}
          </option>
        ))}
      </select>
    </label>
  )
}
